module.exports = __webpack_public_path__ + "static/media/14UNEP27.0aa2b462.jpg";